var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"text":"","dense":"","color":_vm._f("alertColor")(_vm.alert.type),"icon":_vm.alert.icon}},_vm._l((_vm.alert.messages),function(alert){return _c('div',{key:alert},[_c('span',{staticClass:"black--text",domProps:{"innerHTML":_vm._s(alert)}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }